import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import PersonaMoralService from '@/shared/persona/persona-moral.service';
import {
  FiltroPersonaMoral,
  PersonaMoral,
  PERSONAS,
  PERSONAS_MAP,
  SECTORES,
  SECTORES_MAP,
  SubsedeMoral,
} from '@/shared/model/persona/persona-moral.model';
import BuscadorPersonaMoralComponent from '@/components/buscador-personas-morales/buscador-persona-moral.vue';

@Component({
  components: {
    'buscador-persona-moral': BuscadorPersonaMoralComponent,
  },
})
export default class BuscadorPersonasMoralesComponent extends Vue {
  @Inject('personaMoralService') private readonly personaMoralService: () => PersonaMoralService;

  @Prop({ required: false })
  public soloPersona: PERSONAS;

  @Prop({ required: false })
  public soloSector: SECTORES;

  @Prop({ required: false, default: false })
  public seleccionarSoloSede: boolean;

  @Prop({ required: false, default: false })
  public generarSedeComoSubsede: boolean;

  @Prop({ required: false, default: false })
  public mostrarInfo: boolean;

  public filtroNoDeRegistro = '';
  public filtroRfc = '';
  public filtroSector = null;
  public filtrotipoSolicitud = null;
  public personasMorales: Array<PersonaMoral> = [];
  public buscando = false;
  public noEncontrado = false;

  public currentPage = 1;
  public totalRows = 0;
  public perPage = 15;

  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100];

  public readonly opcionesSector = [
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.sectores.todos'), value: null },
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.sectores.publico'), value: SECTORES_MAP[SECTORES.PUBLICO] },
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.sectores.privado'), value: SECTORES_MAP[SECTORES.PRIVADO] },
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.sectores.social'), value: SECTORES_MAP[SECTORES.SOCIAL] },
  ];

  public readonly opcionesTipoSolicitud = [
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.tipoSolicitud.todas'), value: null },
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.tipoSolicitud.personasMorales'), value: PERSONAS_MAP[PERSONAS.MORAL] },
    { text: this.$t('apeironGwApp.buscadorPersonasMorales.tipoSolicitud.personasFisicas'), value: PERSONAS_MAP[PERSONAS.FISICA] },
  ];

  public limpiarFiltros(): void {
    this.filtroNoDeRegistro = '';
    this.filtroRfc = '';
    this.filtroSector = null;
    this.personasMorales = [];
  }

  public cambiarPagina(pagina) {
    this.currentPage = pagina;
    this.buscarPersonasMorales();
  }

  public buscarDesdePrimerPagina() {
    this.currentPage = 1;
    this.buscarPersonasMorales();
  }

  public buscarPersonasMorales(): void {
    this.noEncontrado = false;
    this.buscando = true;
    this.personasMorales = [];

    const filtroPersonaMoral: FiltroPersonaMoral = new FiltroPersonaMoral();

    if (this.filtroNoDeRegistro) filtroPersonaMoral.noDeRegistro = this.filtroNoDeRegistro.split('-')[0];
    if (this.filtroRfc) filtroPersonaMoral.rfc = this.filtroRfc;

    if (this.soloPersona) {
      filtroPersonaMoral.tipoSolicitud = PERSONAS_MAP[this.soloPersona] || '0';
    } else if (this.filtrotipoSolicitud) {
      filtroPersonaMoral.tipoSolicitud = this.filtrotipoSolicitud;
    }

    if (this.soloSector) {
      filtroPersonaMoral.sector = SECTORES_MAP[this.soloSector] || '0';
    } else if (this.filtroSector) {
      filtroPersonaMoral.sector = this.filtroSector;
    }

    this.personaMoralService()
      .findInstituciones(filtroPersonaMoral, this.currentPage, this.perPage)
      .then(result => {
        (result.data ?? []).forEach(personaMoral => {
          const persona = PersonaMoral.fromObject(personaMoral);

          if (this.generarSedeComoSubsede && persona.subsdes?.length < 1 && personaMoral.noDeRegistro) {
            persona.subsdes = [this.obtenerSubsedeDeSede(persona)];
          }

          this.personasMorales.push(persona);
        });
        this.totalRows = Number(result.headers['x-total']);
      })
      .finally(() => {
        this.buscando = false;

        if (this.personasMorales.length < 1) {
          this.noEncontrado = true;
        }
      });
  }

  private obtenerSubsedeDeSede(personaMoral: PersonaMoral): SubsedeMoral {
    const subsede = new SubsedeMoral();

    subsede.claveEntidadFederativa = personaMoral.claveEntidadFederativa;
    subsede.claveMunicipio = personaMoral.claveMunicipio;
    subsede.entidadFederativa = personaMoral.entidadFederativa;
    subsede.esLaSede = true;
    subsede.municipio = personaMoral.municipio;
    subsede.noDeRegistro = personaMoral.noDeRegistro;
    subsede.nombreSede = personaMoral.nombreSede;

    return subsede;
  }

  @Emit('selected')
  public emitirSeleccion(personaMoral: PersonaMoral): PersonaMoral {
    this.limpiarFiltros();

    return personaMoral;
  }
}
